import React, { useContext, useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Approutes from './routing/Approutes.jsx';
import './Style/style.css'
import "swiper/css";
import "swiper/css/free-mode";

import "swiper/css/pagination";
import "swiper/css/grid";
import { Logindetail } from './context/Logindetail.js';
import { Footerpages } from './context/Footerpages.js'
import "aos/dist/aos.css";
import AOS from 'aos'
import toast, { Toaster } from 'react-hot-toast';
import { SchemeDetails } from './context/SchemeDetails.js';
import "react-datepicker/dist/react-datepicker.css";
import { RazarDetails } from './context/razarApi.js';
import axios from 'axios';




function App() {

  const [detail_info, setdetail_info] = useState(JSON.parse(localStorage.getItem('green_login')));
  const [token, settoken] = useState(localStorage.getItem('green_token'))
  // const [settings, setsettings] = useState()
  const [footerpage, setfooterpage] = useState()
  const [emailname, setemailname] = useState()
  const [schemelist, setschemelist] = useState([])
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Hide preloader after app mount
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // 1 second buffer for essential assets
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setdetail_info(JSON.parse(localStorage.getItem('green_login')));
    settoken(localStorage.getItem('green_token'));
    // ...


    //for up down arrow actions in input field
    const disableInputControls = (e) => {
      if (
        e.target.type === 'number' &&
        (e.type === 'wheel' || e.key === 'ArrowUp' || e.key === 'ArrowDown')
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener('wheel', disableInputControls, { passive: false });
    document.addEventListener('keydown', disableInputControls);

    return () => {
      document.removeEventListener('wheel', disableInputControls);
      document.removeEventListener('keydown', disableInputControls);
    };

  }, [localStorage.getItem('green_login'), localStorage.getItem('green_token')])

  // useEffect(() => { fetchKey(); }, []);



  return (
    <div className="">
      <div className={`preloader ${!loading ? 'fade-out' : ''}`}>
        <div className="loader-spinner"></div>
      </div>

      <Logindetail.Provider value={{ detail_info, setdetail_info, settoken, token, emailname, setemailname }}>
        <Footerpages.Provider value={{ footerpage, setfooterpage }}>
          {/* <RazarDetails.Provider value={{ new_razar_key, setNew_razar_key }}> */}
          <SchemeDetails.Provider value={{ schemelist, setschemelist }}>
            <Approutes />
          </SchemeDetails.Provider>
          {/* </RazarDetails.Provider> */}
        </Footerpages.Provider>
      </Logindetail.Provider>
      <Toaster />


    </div>
  );
}
export default App;


